/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   slice.ts
 */

import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { SavedCustomMessage } from '@zcode/state-type'
import type { Mutable } from '@zcode/utility-types'
import { ROOT_STATE_KEY, SAVED_CUSTOM_MESSAGE_INITIAL_STATE } from '../constants'

export const sliceSavedCustomMessage = createSlice({
  name: ROOT_STATE_KEY,
  initialState: SAVED_CUSTOM_MESSAGE_INITIAL_STATE,
  reducers: {
    setCustomMessageChecked: (
      state: Mutable<SavedCustomMessage>,
      { payload }: PayloadAction<boolean>
    ) => {
      state.customMessageChecked = payload
      state.customMessageHasBeenChecked = true
    },
    resetState: (state: Mutable<SavedCustomMessage>) => {
      state.customMessageChecked = false
      state.customMessageHasBeenChecked = false
    },
  },
})
